module.exports = __webpack_public_path__ + "img/type_box.0fe579ca.jpg";